import React from 'react';
import {Link} from "react-router-dom";
import 'react-awesome-slider/dist/styles.css';
import CameraIcon from '@material-ui/icons/Camera';
import insideCircle from '../assets/inner-circle.svg';
import outsideCircle from '../assets/outer-circle.svg';
import wepick from '../assets/wepick.svg';
import tapeat from '../assets/tapeat.svg';
import logo from '../assets/logo-food.svg';
import '../App.scss';

export default function Home() {

    return (
        <div className="button-container">
            <Link to="/spinner" className="spinner-button">
                <CameraIcon style={{display: 'block', marginLeft: 17}}/>
                <span>Roulette</span>
            </Link>
            <Link className="container" to='/food'>
                <img src={outsideCircle} alt="outside-circle" className="main-button"/>
                <img src={insideCircle} alt="inside-circle" className="main-button2 zoom" id="breathing-button"/>
                <img src={logo} alt="logo-circle" className="main-button3"/>
                <img src={tapeat} alt="logo-circle" className="tapeat"/>
                <img src={wepick} alt="logo-circle" className="wepick"/>
            </Link>
        </div>
    );
}
